/** 服务端 Script 与客户端兜底共享的 Sensors 节点 ID。 */
export const SENSORS_SDK_SCRIPT_ID = 'zeelool-sensors-sdk';

/** 当前生产使用的同源 Sensors JavaScript SDK 地址。 */
export const SENSORS_SDK_URL = '/sd.js';

/** 单页面生命周期内复用的 Sensors 加载 Promise。 */
let sensorsSdkPromise: Promise<void> | null = null;

/** 加载 Sensors SDK；优先复用 SSR 节点，否则创建唯一兜底节点。 */
export function loadSensorsSdk(): Promise<void> {
  if (typeof window === 'undefined' || window.sensorsDataAnalytic201505) {
    return Promise.resolve();
  }
  if (sensorsSdkPromise) return sensorsSdkPromise;

  const existingScript = document.getElementById(SENSORS_SDK_SCRIPT_ID);
  let clientScript: HTMLScriptElement | null = null;

  const loadPromise = new Promise<void>((resolve, reject) => {
    /** 创建并监听客户端兜底节点；同一加载流程最多执行一次。 */
    const startClientFallback = () => {
      existingScript?.remove();
      clientScript = document.createElement('script');
      clientScript.id = SENSORS_SDK_SCRIPT_ID;
      clientScript.async = true;
      clientScript.fetchPriority = 'high';
      clientScript.src = SENSORS_SDK_URL;
      clientScript.onload = () => {
        if (window.sensorsDataAnalytic201505) {
          resolve();
          return;
        }
        reject(new Error('Sensors SDK global is unavailable after script load'));
      };
      clientScript.onerror = () => reject(new Error('Failed to load Sensors Analytics script'));
      document.head.appendChild(clientScript);
    };

    if (!existingScript) {
      startClientFallback();
      return;
    }

    const script = existingScript as HTMLScriptElement;
    script.onload = () => {
      if (window.sensorsDataAnalytic201505) {
        resolve();
        return;
      }
      startClientFallback();
    };
    script.onerror = startClientFallback;
  });

  // 加载失败后清理当前兜底节点和缓存 Promise，允许下一次初始化显式重试。
  sensorsSdkPromise = loadPromise.catch((error: unknown) => {
    clientScript?.remove();
    sensorsSdkPromise = null;
    throw error;
  });
  return sensorsSdkPromise;
}
